// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.value-field {
  margin: var(--spacing-small) 0;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/settings/settings-list/settings-list.component.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AACF","sourcesContent":[".value-field {\n  margin: var(--spacing-small) 0;\n}\n\n.button-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
